module.exports = __webpack_public_path__ + "media/images/flavours/icon-fruit-rouge_dark-7998c161f9cdd2d4d57bfd074b166e4a.png";